import React from "react";
import PropTypes from "prop-types";
import { Box } from "@chakra-ui/react";

const preloaderWrapStyles = {
  position: "absolute",
  width: "full",
  height: "full",
  zIndex: 2,
  top: 0,
  left: 0,
  background: "blackAlpha.600",
};

const PreloaderWrapper = ({ children, styles, ...props }) => (
  <Box sx={{ ...preloaderWrapStyles, ...styles }} {...props}>
    {children}
  </Box>
);

PreloaderWrapper.propTypes = {
  styles: PropTypes.object,
  children: PropTypes.node.isRequired,
};

export default PreloaderWrapper;
